import { render } from "./ReportWrapper.vue?vue&type=template&id=5c5f1c37"
import script from "./ReportWrapper.vue?vue&type=script&lang=js"
export * from "./ReportWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/home/nils/assessment_tool/code/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__